import gql from 'graphql-tag';
import { FULL_NOTE_FRAGMENT } from './fragments';

export const noteQuery = gql`
  query Note($id: ID!) {
    note(id: $id) {
      ...FullNote
    }
  }
  ${FULL_NOTE_FRAGMENT}
`;

export const deleteNoteMutation = gql`
  mutation NoteDeleteMutation($input: DeleteNoteInput!) {
    deleteNote(input: $input) {
      errors {
        path
        message
      }
    }
  }
`;

export const notesQuery = gql`
  query NotesQuery($input: NotesQueryInput!) {
    notes(input: $input) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          ... on Note {
            ...FullNote
          }
        }
      }
    }
  }
  ${FULL_NOTE_FRAGMENT}
`;

// this is a duplicate of notesQuery until we get rid of the input object of
// graphql endpoints that rely on pagination
export const mostRecentNoteQuery = gql`
  query MostRecentNoteQuery($input: NotesQueryInput!) {
    notes(input: $input) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          ... on Note {
            ...FullNote
          }
        }
      }
    }
  }
  ${FULL_NOTE_FRAGMENT}
`;

export const noteCreateOrUpdateMutation = gql`
  mutation NoteCreateOrUpdateMutation($input: CreateOrUpdateNoteInput!) {
    createOrUpdateNote(input: $input) {
      errors {
        path
        message
      }
      note {
        id
      }
    }
  }
`;
